/* eslint-disable no-alert */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useRef, useCallback, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { Base64 } from 'js-base64'

import { FiArrowLeft, FiX, FiArrowRight } from 'react-icons/fi'
import IconButton from '@material-ui/core/IconButton'
import Collapse from '@material-ui/core/Collapse'
import Alert from '@material-ui/lab/Alert'

import usePersistedState from '../../hooks/usePersistedState'
import InputSMSCode from '../../components/InputSMSCode'
import api from '../../services/api'

import Button from '../../components/Button'
import Header from '../../components/Header'

import {
  UserData,
  UserDetails,
  LegalResponsibleData,
  FinancialResponsibleData,
  IndicationData,
  ConfigData,
  UserAccount,
  ErroProps,
  Participant,
} from '../../utils/interfaces'
import { Container, Content, Timer } from './styles'

const ConfirmSMS: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)
  const [userDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [userAccount] = usePersistedState<UserAccount>(
    'userAccount',
    {} as UserAccount,
  )

  const [legalRespData] = usePersistedState<LegalResponsibleData>(
    'legalRespData',
    {} as LegalResponsibleData,
  )

  const [financialRespData] = usePersistedState<FinancialResponsibleData>(
    'financialRespData',
    {} as FinancialResponsibleData,
  )

  const [indicationData] = usePersistedState<IndicationData>(
    'indicationData',
    {} as IndicationData,
  )

  const [participantsList] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )

  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )

  const [selectedReceive] = usePersistedState<'PD' | 'PS' | null>(
    'receiveTypeSelected',
    'PS',
  )

  const [percentualValuePercent] = usePersistedState<number>(
    'PercentualValuePercent',
    0.3,
  )

  const [timeValueYears] = usePersistedState<number>('TimeValueYears', 1)

  const [sizeCode] = useState(4)
  const [timer, setTimer] = useState(60)
  const [reSend, setReSend] = useState(false)
  const [open, setOpen] = useState(false)
  const [aguarde, setAguarde] = useState(false)

  const history = useHistory()
  const formRef = useRef<FormHandles>(null)
  const contato = configData.tipoContato === 'S' ? 'SMS' : 'e-mail'

  const handleAdesao = useCallback(async () => {
    const parametros = Base64.encode(
      `{"token": "${configData.token}",
      "versao": "${configData.tipo}",
      "plano": "${configData.plano}",
      "nome": "${userData.name.toLowerCase()}",
      "cpf": "${userData.cpf
        .replace('.', '')
        .replace('.', '')
        .replace('-', '')}",
      "nascimento": "${userData.birthdate}",
      "email": "${userData.email}",
      "telefone": "55${userData.phone
        .replace('(', '')
        .replace(') ', '')
        .replace('-', '')}",
      "nomeMae": "${userData.parental.toLowerCase()}",
      "valor": "${userDetails.contribuicaoBasica
        .toFixed(2)
        .toString()
        .replaceAll('.', ',')}",
      "tempo_contribuicao": "${userDetails.years}",
      "aporteInicial": "${userDetails.aport
        .toFixed(2)
        .toString()
        .replaceAll('.', ',')}",
      "politicamenteexposto": "${userDetails.ppe}",
      "usperson": "${userDetails.usperson}",
      "banco":"${
        userAccount.banco === null || userAccount.banco === undefined
          ? ''
          : userAccount.banco
      }",
      "agencia":"${
        userAccount.agencia === null || userAccount.agencia === undefined
          ? ''
          : userAccount.agencia
      }",
      "conta":"${
        userAccount.conta === null || userAccount.conta === undefined
          ? ''
          : userAccount.conta
      }",
      "formaPagamento": "${userAccount.paymentType}",
      "valor_resgate": "${
        selectedReceive === 'PS'
          ? percentualValuePercent.toFixed(2).toString().replaceAll('.', ',')
          : timeValueYears
      }",
      "forma_resgate": "${selectedReceive}",
      "cpfIndicacao": "${
        indicationData.cpfIndicacao === undefined
          ? ''
          : indicationData.cpfIndicacao
              .replace('.', '')
              .replace('.', '')
              .replace('-', '')
      }",
      "parentescoIndicacao": "${
        indicationData.grauParentesco === undefined
          ? ''
          : indicationData.grauParentesco
      }",
      "nomeIndicacao" : "${
        indicationData.nomeIndicacao.toLowerCase() === undefined
          ? ''
          : indicationData.nomeIndicacao.toLowerCase()
      }",
      "cpfRespFinanc": "${
        financialRespData.cpfResponsavel === undefined
          ? ''
          : financialRespData.cpfResponsavel
              .replace('.', '')
              .replace('.', '')
              .replace('-', '')
      }",
      "emailRespFinanc": "${
        financialRespData.emailResponsavel === undefined
          ? ''
          : financialRespData.emailResponsavel
      }",
      "nomeRespFinanc": "${
        financialRespData.nomeResponsavel === undefined
          ? ''
          : financialRespData.nomeResponsavel.toLowerCase()
      }",
      "telRespFinanc": "${
        financialRespData.telResponsavel === undefined ||
        financialRespData.telResponsavel === ''
          ? ''
          : `55${financialRespData.telResponsavel
              .replace('(', '')
              .replace(') ', '')
              .replace('-', '')}`
      }",
      "respLegal": [{
        "cpfRespLeg": "${
          legalRespData.cpfResponsavelLeg === undefined
            ? ''
            : legalRespData.cpfResponsavelLeg
                .replace('.', '')
                .replace('.', '')
                .replace('-', '')
        }",
        "emailRespLeg": "${
          legalRespData.emailResponsavelLeg === undefined
            ? ''
            : legalRespData.emailResponsavelLeg
        }",
        "nomeRespLeg": "${
          legalRespData.nomeResponsavelLeg === undefined
            ? ''
            : legalRespData.nomeResponsavelLeg.toLowerCase()
        }",
        "telRespLeg": "${
          legalRespData.telResponsavelLeg === undefined ||
          legalRespData.telResponsavelLeg === ''
            ? ''
            : `55${legalRespData.telResponsavelLeg
                .replace('(', '')
                .replace(') ', '')
                .replace('-', '')}`
        }"}
      ],
      "beneficiarios": [${participantsList.map(
        participant => `
        {"nome": "${participant.data.name.toLowerCase()}",
        "nascimento": "${participant.data.birthdate}",
        "cpf": "${participant.data.cpf.replaceAll('.', '').replace('-', '')}",
        "parentesco":"${participant.details.grauParentesco}",
        "tipo":""}`,
      )}]
      }`,
    )

    // const seguro = {
    //   "seguro":[{
    //     "seguro_pensao": "${userDetails.valorPensao
    //       .toFixed(2)
    //       .toString()
    //       .replaceAll('.', ',')}",
    //     "premio_pensao": "${userDetails.vlrPremioPens
    //       .toFixed(2)
    //       .toString()
    //       .replaceAll('.', ',')}",
    //     "cod_pensao":"11",
    //     "seguro_aposentadoria": "${userDetails.valorAposentadoria
    //       .toFixed(2)
    //       .toString()
    //       .replaceAll('.', ',')}",
    //     "premio_aposentadoria": "${userDetails.vlrPremioApos
    //       .toFixed(2)
    //       .toString()
    //       .replaceAll('.', ',')}",
    //     "cod_aposentadoria":"12"
    //   }],
    // }

    const parametrosFinal = Base64.encode(parametros)

    await api
      .post(`wsAdesao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(() => {
        localStorage.removeItem('@CERES:authTerms')
        localStorage.removeItem('@CERES:erroProps')
        localStorage.removeItem('@CERES:financialRespData')
        localStorage.removeItem('@CERES:Indicado')
        localStorage.removeItem('@CERES:indicationData')
        localStorage.removeItem('@CERES:legalRespData')
        localStorage.removeItem('@CERES:participantsGroup')
        localStorage.removeItem('@CERES:PercentualValuePercent')
        localStorage.removeItem('@CERES:receiveTypeSelected')
        localStorage.removeItem('@CERES:respFinanceiro')
        localStorage.removeItem('@CERES:respLegal')
        localStorage.removeItem('@CERES:respLegalEqualFin')
        localStorage.removeItem('@CERES:TimeValueYears')
        localStorage.removeItem('@CERES:totalBalance')
        localStorage.removeItem('@CERES:totalRentability')
        localStorage.removeItem('@CERES:userAccount')
        localStorage.removeItem('@CERES:userData')
        localStorage.removeItem('@CERES:userDetails')
        history.push('/end')
      })
      .catch(res => {
        if (res.message === 'Request failed with status code 401') {
          alert('Tempo de sessão expirado')
          history.push('/')
        } else if (res.message === 'Request failed with status code 406') {
          alert(
            'Adesão não autorizada. Verifique se você já possui cadastro no plano.',
          )
        } else if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão como servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 408') {
          alert('Tempo de sessão expirado')
          history.push('/')
        } else {
          alert('Ops, algo deu errado. Tente novamente mais tarde.')
        }
      })
    setAguarde(false)
  }, [
    configData,
    userData,
    userDetails,
    userAccount,
    selectedReceive,
    percentualValuePercent,
    timeValueYears,
    indicationData,
    financialRespData,
    legalRespData,
    participantsList,
    history,
    setErroProps,
  ])

  const handleSubmit = useCallback(
    async data => {
      setAguarde(true)
      if (data.codeSMS.length === sizeCode) {
        const parametros = Base64.encode(
          `{"token": "${configData.token}",
          "codigoValidador": "${data.codeSMS}",
          "cliente": ${configData.codCliente}}`,
        )

        const parametrosFinal = Base64.encode(parametros)

        await api
          .post(`wsAutenticacao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
          .then(() => {
            handleAdesao()
          })
          .catch(res => {
            if (res.message === 'Request failed with status code 401') {
              setOpen(true)
            } else {
              alert('Ops, algo deu errado. Tente novamente mais tarde.')
            }
            setAguarde(false)
          })
      }
    },
    [sizeCode, configData, handleAdesao],
  )

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }

    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  const handleReSend = useCallback(() => {
    const parametrosGet = Base64.encode(
      `{"versao":"${configData.tipo}",
      "plano": "${configData.plano}",
      "email":"${userData.email}",
      "telefone":"${
        userData.phone === undefined
          ? ''
          : `55${userData.phone
              .replace('(', '')
              .replace(') ', '')
              .replace('-', '')}`
      }",
      "cpf":"",
      "admissão":"",
      "cliente":"${configData.codCliente}",
      "sistema":"ADZ",
      "envio":"${configData.tipoContato}"}`,
    )

    const parametrosFinalGet = Base64.encode(parametrosGet)

    api
      .get(`wsAutenticacao.rule?sys=ADZ&Entrada=${parametrosFinalGet}`)
      .then(res => setConfigData({ ...configData, token: res.data.token }))
      .catch(() => alert('Ops, algo deu errado. Tente novamente mais tarde.'))

    history.push('/register/confirm-sms')

    setReSend(false)
    setTimer(60)
    window.location.reload(false)
  }, [history, configData, setConfigData, userData.email, userData.phone])

  const handleChangeValues = useCallback(() => {
    history.push('/resume')
  }, [history])

  return (
    <>
      <Header>
        <FiArrowLeft
          type="button"
          cursor="pointer"
          onClick={handleChangeValues}
        />
      </Header>

      <Container>
        <Collapse in={open}>
          <Alert
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  window.location.reload(false)
                }}
              >
                <FiX fontSize="inherit" />
              </IconButton>
            }
          >
            Código incorreto!
          </Alert>
          <br />
        </Collapse>
        <Content>
          <h3>
            Estamos <strong>quase terminando</strong>
          </h3>
          <p>
            <span>{userData?.name.split(' ')[0]}</span>, digite aqui o código de
            verificação que acabamos de te enviar via {contato}.
          </p>

          <Form ref={formRef} onSubmit={handleSubmit}>
            <InputSMSCode
              name="codeSMS"
              size={sizeCode}
              formRef={formRef}
              disabled={aguarde}
            />
          </Form>

          <span>
            Não recebeu o código em um minuto?
            <br />
            Clique em reenviar e pronto!
          </span>
          <Timer>00:{timer < 10 ? `0${timer}` : timer}</Timer>

          <Button
            onClick={handleReSend}
            type="button"
            color="green"
            disabled={!reSend || aguarde}
          >
            Reenviar
            <div>
              <FiArrowRight />
            </div>
          </Button>
          <Button
            type="button"
            color="transparent"
            onClick={handleChangeValues}
            disabled={aguarde}
          >
            <div>
              <FiArrowLeft />
            </div>
            Quero trocar a forma de contato
          </Button>
        </Content>
      </Container>
    </>
  )
}

export default ConfirmSMS
